/* global window */

import * as ACTIONS from '../actions/constants';

const initialState = {
  Authorized: false,
  errors: [],
  info: {},
  cashPaymentEnabled: false
};

function mapUserData(obj) {
  return {
    roles: obj['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
    login: obj['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']
  };
}

function decodeJWT(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const obj = JSON.parse(window.atob(base64));
  return mapUserData(obj);
}

const setUserData = (payload) => {
  const decodedToken = decodeJWT(payload.token);
  return {
    token: payload.token,
    Authorized: true,
    info: decodedToken, // here for backward compatibility now i've flattented it.
    ...decodedToken,
    location: payload.location,
    isTelStore: payload.isTelStore
  };
};

function sofologist(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SOFOLOGIST_LOG_IN_ERRORS:
      return { ...state, errors: [action.payload.message] };
    case ACTIONS.SOFOLOGIST_LOG_OUT:
      return initialState;
    case ACTIONS.SOFOLOGIST_LOG_IN:
      return { ...state, ...setUserData(action.payload) };
    case ACTIONS.UPDATE_ALL_STORES:
      return { ...state, stores: action.payload };
    case ACTIONS.CASH_PAYMENT_CONFIG_LOADED:
      return { ...state, cashPaymentEnabled: action.payload };
    default:
      return state;
  }
}

export default sofologist;



// WEBPACK FOOTER //
// ./src/reducers/sofologist.js